/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Dataflow_SourcesInputs */

const en_landing_dataflow_sources = /** @type {(inputs: Landing_Dataflow_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Sources`)
};

const de_landing_dataflow_sources = /** @type {(inputs: Landing_Dataflow_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job-Quellen`)
};

const fr_landing_dataflow_sources = /** @type {(inputs: Landing_Dataflow_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Sources`)
};

const es_landing_dataflow_sources = /** @type {(inputs: Landing_Dataflow_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Sources`)
};

const it_landing_dataflow_sources = /** @type {(inputs: Landing_Dataflow_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Sources`)
};

const nl_landing_dataflow_sources = /** @type {(inputs: Landing_Dataflow_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Sources`)
};

const pl_landing_dataflow_sources = /** @type {(inputs: Landing_Dataflow_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Sources`)
};

const fi_landing_dataflow_sources = /** @type {(inputs: Landing_Dataflow_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Sources`)
};

const da_landing_dataflow_sources = /** @type {(inputs: Landing_Dataflow_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Sources`)
};

const sv_landing_dataflow_sources = /** @type {(inputs: Landing_Dataflow_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Sources`)
};

/**
* | output |
* | --- |
* | "Job Sources" |
*
* @param {Landing_Dataflow_SourcesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_dataflow_sources = /** @type {((inputs?: Landing_Dataflow_SourcesInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Dataflow_SourcesInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_dataflow_sources(inputs)
	if (locale === "fr") return fr_landing_dataflow_sources(inputs)
	if (locale === "es") return es_landing_dataflow_sources(inputs)
	if (locale === "it") return it_landing_dataflow_sources(inputs)
	if (locale === "nl") return nl_landing_dataflow_sources(inputs)
	if (locale === "pl") return pl_landing_dataflow_sources(inputs)
	if (locale === "fi") return fi_landing_dataflow_sources(inputs)
	if (locale === "da") return da_landing_dataflow_sources(inputs)
	if (locale === "sv") return sv_landing_dataflow_sources(inputs)
	return en_landing_dataflow_sources(inputs)
});